export const TaskStatus = [
  { label: "0%", value: 0, color: "black" },
  { label: "25%", value: 25, color: "black" },
  { label: "50%", value: 50, color: "black" },
  { label: "75%", value: 75, color: "black" },
  { label: "100%", value: 100, color: "black" }
];
